<template>
  <b-modal
    id="modal-field"
    :title="editMode == true ? $t('general.edit') : $t('general.add_application')"
    :ok-title="editMode == true ? $t('general.edit') : $t('general.save')"
    cancel-variant="outline-secondary"
    ok-variant="success"
    :cancel-title="$t('cancel')"
    centered
    no-close-on-backdrop
    @show="showModal"
    @ok="onSubmit"
  >
    <validation-observer ref="transportAddModal">
      <b-row class="material">

        <b-col md="12">
          <b-form-group :label="$t('date')">
            <validation-provider
              #default="{ errors }"
              :name="$t('date')"
              rules="required"
            >
              <!-- <VueDataPicker
                :returnFormat="'YYYY-MM-DD h:mm:ss'"
                class="date-dark"
                v-model="transport.start_date"
                placeholder="YYYY-MM-DD"
                :state="errors.length > 0 ? false : null"
              /> -->
              <!-- <h5>Date & TIme</h5> -->
              <flat-pickr
                v-model="transport.start_date"
                class="form-control"
                :config="dateConfig"
              />
                <!-- :disabled="viewMode"
                :readonly="viewMode" -->
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>


        <b-col md="12">
          <b-form-group :label="$t('transport')">
            <validation-provider
              #default="{ errors }"
              :name="$t('transport')"
              rules="required"
            >
              <v-select
                v-model="transport.transport_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="GET_TRANSPORT.results"
              >
                <!-- @input="onBrigadeSelected()" -->
                <li slot="list-footer" class="pagination">
                  <button :disabled="!GET_TRANSPORT.previous" @click="previous">
                    {{ $t("prev") }}
                  </button>
                  <button :disabled="!GET_TRANSPORT.next" @click="nextFunc">
                    {{ $t("next") }}
                  </button>
                </li>
              </v-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        
        <b-col md="12">
          <b-form-group :label="$t('amount')">
            <validation-provider
              #default="{ errors }"
              :name="$t('amount')"
              rules="required"
            >
              <b-form-input
                v-model="transport.count"
                type="text"
                @input="formatPrice(transport.count, 'count')"
                onkeypress="return /[0-9,/.]/i.test(event.key)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>


        <b-col md="12">
          <b-form-group :label="$t('price_per_hour')">
            <!-- <validation-provider
              #default="{ errors }"
              :name="$t('price_per_hour')"
              rules="required"
            > -->
              <b-form-input
                v-model="transport.price_per_hour"
                type="text"
                @input="formatPrice(transport.count, 'count')"
                onkeypress="return /[0-9,/.]/i.test(event.key)"
              />
              <!-- <small class="text-danger">{{ errors[0] }}</small> -->
            <!-- </validation-provider> -->
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group :label="$t('hours_used')">
            <!-- <validation-provider
              #default="{ errors }"
              :name="$t('hours_used')"
              rules="required"
            > -->
              <b-form-input
                v-model="transport.working_hours"
                type="text"
                @input="formatPrice(transport.count, 'count')"
                onkeypress="return /[0-9,/.]/i.test(event.key)"
              />
              <!-- <small class="text-danger">{{ errors[0] }}</small> -->
            <!-- </validation-provider> -->
          </b-form-group>
        </b-col>


        <b-col md="12">
          <b-form-group :label="$t('contact.comment')">
            <validation-provider
              #default="{ errors }"
              :name="$t('contact.comment')"
              rules="required"
            >
              <b-form-textarea v-model="transport.comment" type="text" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
    </validation-observer>
  </b-modal>
</template>

<script>
import { BRow, BCol, BFormGroup, BFormInput, BModal, BFormTextarea } from "bootstrap-vue";
import vSelect from "vue-select";
import { mapActions, mapGetters } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from "@core/utils/validations/validations";
import VueDataPicker from "@/components/VueDatePicker.vue";
import flatPickr from 'vue-flatpickr-component'
import { Russian } from "flatpickr/dist/l10n/ru.js"

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BModal,
    VueDataPicker,
    flatPickr,
    BFormTextarea
  },
  props: {
    transportss: {
      type: Object,
      default: () => ({}),
      required: false,
    },
  },
  data() {
    return {
      // ===============  PRIMARY_DATA_SECTION START ===============
      required,
      search: "",

      transport: {
        start_date: null,
        price_per_hour: null,
        working_hours: null,
        transport_id: '',
        count: 0,
        comment: '',
        id: ''
      },
      editMode: false,
      dateConfig: { enableTime: true, dateFormat: 'Y-m-d H:i', locale: Russian}
    };
    // ===============  PRIMARY_DATA_SECTION END ===============
  },
  computed: {
    ...mapGetters("transport", [
      "GET_TRANSPORT",
    ]),
  },
  async mounted() {




    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.FETCH_TRANSPORT();
    // ===============  PRIMARY_REQUESTS_SECTION END ===============





  },
  methods: {
    ...mapActions("transport", [
      "FETCH_TRANSPORT",
    ]),






    // ===============  PREVIOUS_NEXT_PAGE_SECTION START ===============
    async previous() {
      if (this.GET_TRANSPORT.previous) {
        const page = this.GET_TRANSPORT.previous;

        await this.FETCH_TRANSPORT({ 
          category: this.goods && this.goods.category 
          && this.goods.category.id ? this.goods.category.id : 0,
          page: page, 
          pagination: "number",
        });
      }
    },
    async nextFunc() {
      if (this.GET_TRANSPORT.next) {
        const page = this.GET_TRANSPORT.next;

        await this.FETCH_TRANSPORT({ 
          category: this.goods && this.goods.category && this.goods.category.id ? this.goods.category.id : 0,
          page: page, 
          pagination: "number",
        });
      }
    },
    // ===============  PREVIOUS_NEXT_PAGE_SECTION START ===============















    // ===============  SHOW_MODAL_SECTION START ===============
    showModal() {
      this.editMode = this.$route.params.editMode;
      this.transport = {
        id: null,
        start_date: null,
        price_per_hour: null,
        working_hours: null,
        transport_id: null,
        count: null,
        comment: null
      };

      if (!this.transportss) {
        return;
      }

      if (typeof this.transportss === "object" && this.transportss !== null) {
        if (!this.transportss) {
          return;
        }

        this.transport.id = this.transportss.id;
        this.transport.start_date = this.transportss.start_date;
        this.transport.price_per_hour = this.transportss.price_per_hour;
        this.transport.working_hours = this.transportss.working_hours;
        this.transport.transport_id = this.transportss.transport_id;
        this.transport.count = this.transportss.count;
        this.transport.comment = this.transportss.comment;
      }
    },
    // ===============  SHOW_MODAL_SECTION END ===============







    // ===============  FORMAT_PRICE_SECTION START ===============
    formatPrice(value, type) {
      if (value) {
        let currency = value.toString().replace(/,/g, "");
        currency = parseFloat(currency);
        currency = new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }).format(currency);

        if (type == "count") {
          this.transport.count = currency;
        }
      }
      return 0;
    },
    // ===============  FORMAT_PRICE_SECTION END ===============









    // ===============  ON_SUBMIT_SECTION START ===============
    async onSubmit(bvModalEvt) {
      bvModalEvt.preventDefault();
      await this.$refs.transportAddModal.validate().then(async (success) => {
        if (!success) {
          this.$_errToast({ message: this.$t("all_fields_are_required") });
          return;
        }
        try {
          this.$nextTick(() => {
            this.$route.params.editMode = false;
            this.$emit("onSave", this.transport);
            this.$bvModal.hide("modal-field");
          });
          this.$_okToast();
        } catch (err) {
          console.log(err);
          // this.$_errToast('Error')
        }
      });
    },
    // ===============  ON_SUBMIT_SECTION END ===============








  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.material .vs--disabled .vs__dropdown-toggle,
[dir] .vs--disabled .vs__clear,
[dir] .vs--disabled .vs__search,
[dir] .vs--disabled .vs__selected,
[dir] .vs--disabled .vs__open-indicator {
  cursor: not-allowed;
  background-color: transparent !important;
}

.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
}
.pagination button {
  flex-grow: 1;
  border: 1px solid #ccc;
}
.pagination button:hover {
  cursor: pointer;
}
</style>
